﻿export function setupManufacturerInsightsDatatable() {
    const table = $('#car-sales-figures-table').DataTable({
        responsive: true,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function (oSettings) {
            $('.dataTables_paginate').hide();
        }
    });
}